import * as yup from 'yup';

import { createHighestRateValidation, createLowestRateValidation } from 'src/utils/validations';

import { TWO_TOGGLE_PRICING_TYPES } from '../components/TwoToggleRates';
import { SAFE_PAYMENTS_OPTIONS, WORLDPAY_OPTIONS } from '../sections/CompliancePricing';

const createSchemaForOptions = (options: { name: string }[]) => {
    const perItemValidation = yup
        .number()
        .when('type', (type: string, schema: yup.NumberSchema) => {
            return type === 'PER_ITEM' ? schema.required() : schema.notRequired();
        });

    const fixedRateValidation = yup
        .number()
        .when('type', (type: string, schema: yup.NumberSchema) => {
            return type === 'FIXED' ? schema.required() : schema.notRequired();
        });

    const typeOptions = TWO_TOGGLE_PRICING_TYPES.map((item) => {
        return item.value;
    });

    const cardSchema = yup.object().shape({
        type: yup.string().oneOf(typeOptions),
        baseRate: perItemValidation,
        lowestRate: perItemValidation.test(
            'lowest-rate-validation',
            'Lowest rate cannot exceed highest rate',
            createLowestRateValidation('lowestRate', 'highestRate')
        ),
        highestRate: perItemValidation.test(
            'highest-rate-validation',
            'Highest rate cannot be less than lowest rate',
            createHighestRateValidation('lowestRate', 'highestRate')
        ),
        fixedRate: fixedRateValidation,
    });

    return options.reduce(
        (acc, { name }) => {
            return {
                ...acc,
                [name]: cardSchema,
            };
        },
        {} as Record<string, yup.ObjectSchema<any>>
    );
};

const getValidationShape = () => {
    return yup.object().shape({
        worldpayProgramme: yup.object().shape(createSchemaForOptions(WORLDPAY_OPTIONS)),
        safePayments: yup.object().shape(createSchemaForOptions(SAFE_PAYMENTS_OPTIONS)),
    });
};

export const COMPLIANCE_PRICING_VALIDATION_SCHEMA = getValidationShape();
